import getterTypes from './getter-types'

export default {
  [getterTypes.GET_OFFER_MEAL]: state => state.offerMeal,
  [getterTypes.GET_SOLD_OUT]: state => state.soldOut,
  [getterTypes.GET_UPDATED_OFFER_MEAL_ID]: state => state.updatedOfferMealId,
  [getterTypes.GET_VISIBLE]: state => state.visible,
  [getterTypes.GET_PRICE_FORMATTED]: state => state.priceFormatted,
  [getterTypes.GET_VALID]: state => state.valid,
  [getterTypes.GET_ERRORS]: state => state.errors,
  [getterTypes.GET_PACKAGING_PRICE_FORMATTED]: state => state.packagingPriceFormatted,
}
